<template>
  <div style="min-height: 0.2rem; padding-bottom: 0.25rem">
    <div data-blur="0" data-show="1" class="M1hv08Saat6oRJv0Gy45">
      <div
        class="OFDZaczxvoDfCgBfAY3h"
        data-components-name="coms-theme-1-footer"
      >
        <template></template>
        <section class="LseXQWJMvDiV2XalL3sA">
          <div class="pU9uCahuI5X16Y5schiY">
            <div class="bUGFPYZ0IBtUg6TvqFnc vertival-box">
              <div class="UJY0E549iXw8BAops2og item-box">
                <div class="JxE2bCrlce_jVHNQ56UL link-list-title">
                  {{ $t('_home._Cassino') }}
                </div>
                <div class="dIvaBEC9yHdlaEHxlYwe item-list">
                  <div
                    class="m4LhLKEZzJw_JjBFp0PP link-list-item"
                    @click="openUrl('event')"
                  >
                    {{ $t('_home._Eventos') }}
                  </div>
                  <div
                    class="m4LhLKEZzJw_JjBFp0PP link-list-item ImbZfuNlIcC1JuS98DxH"
                  >
                    {{ $t('_home._Missão') }}
                  </div>
                  <div
                    class="m4LhLKEZzJw_JjBFp0PP link-list-item"
                    @click="openUrl('canReceive')"
                  >
                    {{ $t('_home._Pendente') }}
                  </div>
                  <div
                    class="m4LhLKEZzJw_JjBFp0PP link-list-item"
                    @click="openUrl('vip')"
                  >
                    {{ $t('_home._VIP') }}
                  </div>
                  <div class="m4LhLKEZzJw_JjBFp0PP link-list-item">
                    {{ $t('popup._Agente') }}
                  </div>
                  <div
                    class="m4LhLKEZzJw_JjBFp0PP link-list-item"
                    @click="openUrl('rechargeFund')"
                  >
                    {{ $t('_home._FundodePrevidência') }}
                  </div>
                </div>
              </div>
              <div class="UJY0E549iXw8BAops2og item-box">
                <div class="JxE2bCrlce_jVHNQ56UL link-list-title">
                  {{ $t('_home._Jogos') }}
                </div>
                <div class="dIvaBEC9yHdlaEHxlYwe item-list">
                  <div class="m4LhLKEZzJw_JjBFp0PP link-list-item">
                    {{ $t('_home._Slots') }}
                  </div>
                  <div class="m4LhLKEZzJw_JjBFp0PP link-list-item">
                    {{ $t('_home._Blockchain') }}
                  </div>
                </div>
              </div>
              <div class="UJY0E549iXw8BAops2og item-box">
                <div class="JxE2bCrlce_jVHNQ56UL link-list-title">
                  {{ $t('_home._Suporte') }}
                </div>
                <div class="dIvaBEC9yHdlaEHxlYwe item-list">
                  <div
                    class="m4LhLKEZzJw_JjBFp0PP link-list-item"
                    @click="openUrl('notice')"
                  >
                    {{ $t('_home._Suporte') }}
                  </div>
                  <div
                    class="m4LhLKEZzJw_JjBFp0PP link-list-item"
                    @click="openUrl('notice')"
                  >
                    {{ $t('_home._CentraldeAjuda') }}
                  </div>
                  <div class="m4LhLKEZzJw_JjBFp0PP link-list-item">
                    {{ $t('_home._BônusdeSugestão') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="mmVblCO1C2DkoUeKEY2w">
              <div class="M9sYhkFFQiFmM32ifMp5 channel-box">
                <div class="u_ecgPCLkRaUsesukqAW">
                  {{ $t('components._CanalOficial') }}
                </div>
                <div class="BCZ4CKkRqkon2n_mgG1Q">
                  <img
                    v-if="$store.state.config.cnpj_link != '@'"
                    @click="openUrlCsusy(config.cnpj_link)"
                    src="./../../../assets/kuaijiexiaz/cnpj.png"
                    class="goDRiiBsuEuXD3W1NphN UFAFwugOhgpx7Zb7eUTn channel-item"
                  />
                  <img
                    @click="openUrlCsusy(config.instagram)"
                    src="./../../../assets/kuaijiexiaz/1795519195972894722.png"
                    class="goDRiiBsuEuXD3W1NphN UFAFwugOhgpx7Zb7eUTn channel-item"
                  />
                  <img
                    @click="openUrlCsusy(config.whatsapp)"
                    src="./../../../assets/kuaijiexiaz/img_wa.png"
                    class="goDRiiBsuEuXD3W1NphN UFAFwugOhgpx7Zb7eUTn channel-item"
                  />
                </div>
              </div>
            </div>
            <div class="company-info">
              <div class="yIl5wRiijLc7UrecEbyO infoArea">
                <div class="PtU3fLkIewRcrUlhRYyd text">
                  <p>{{ config.explain_description }}</p>
                </div>
              </div>
            </div>
            <div
              class="logo-area"
              style="
                display: flex;
                flex-wrap: wrap;
                padding: 0 0.5rem;
                justify-content: center;
                margin-top: 0.4rem;
              "
            >
              <div v-for="item in list" style="display: flex; height: 0.38rem">
                <img :src="item" />
              </div>
              <div
                style="
                  color: var(--theme-text-color-lighten);
                  font-size: 0.18rem;
                  margin-top: 17px;
                "
              >
                {{ config.project_name }}{{ config.copyright }}
              </div>
            </div>
            <template></template><template></template>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import APopup from '@/components/Idioma-popup/index.vue';
export default {
  name: 'records',
  computed: {
    ...mapState(['popList', 'userInfo', 'moneyInfo', 'config'])
  },
  data() {
    return {
      list: [
        require('@/assets/icons/3Dian5/10001.png'),
        require('@/assets/icons/3Dian5/10002.png'),
        require('@/assets/icons/3Dian5/10003.png'),
        require('@/assets/icons/3Dian5/10004.png'),
        require('@/assets/icons/3Dian5/10005.png'),
        require('@/assets/icons/3Dian5/10006.png'),
        require('@/assets/icons/3Dian5/10007.png'),
        require('@/assets/icons/3Dian5/10008.png'),
        require('@/assets/icons/3Dian5/10009.png')
      ],
    };
  },
  methods: {
    openUrlCsusy(e) {
      if (e != '#') {
        window.open(e, '_blank');
      }
    }
  }
};
</script>

<style scoped>
.vertival-box:after {
  border-bottom: none;
  height: 0 !important;
}
.vertival-box {
  padding-bottom: 0;
}
.TNhhMltbvlGJmWgLd9F5 {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  gap: 0.15rem;
  justify-content: center;
  margin-top: 0.4rem;
}

.TNhhMltbvlGJmWgLd9F5 .QP1fgnfNl3ak5aLI38nQ .I4r5jH_hdzbxrjf7nkFg {
  height: 100%;
}

.TNhhMltbvlGJmWgLd9F5 .utwehnHMr2EwsIo5BpHh {
  height: auto !important;
}
.mmVblCO1C2DkoUeKEY2w {
  display: -ms-flexbox;
  display: flex;
  position: relative;
}

.pU9uCahuI5X16Y5schiY .mmVblCO1C2DkoUeKEY2w .teae_NnPrM2iLkzhOMBf {
  -ms-flex: 1;
  flex: 1;
  overflow: hidden;
  padding-right: 0.1rem;
}

.pU9uCahuI5X16Y5schiY
  .mmVblCO1C2DkoUeKEY2w
  .teae_NnPrM2iLkzhOMBf
  .bqDYlJVo_WYcY76yRl6u {
  color: var(--theme-text-color-lighten);
  font-size: 0.24rem;
  margin-bottom: 0.2rem;
}

.pU9uCahuI5X16Y5schiY
  .mmVblCO1C2DkoUeKEY2w
  .teae_NnPrM2iLkzhOMBf
  .REDtSdf0w9HK2n0VYpm0 {
  color: var(--theme-text-color);
  font-size: 0.24rem;
  margin-bottom: 0.1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pU9uCahuI5X16Y5schiY .mmVblCO1C2DkoUeKEY2w:after {
  background-color: var(--theme-color-line);
  bottom: 0;
  content: '';
  height: 0.01rem;
  left: 50%;
  position: absolute;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 100%;
}

.pU9uCahuI5X16Y5schiY .mmVblCO1C2DkoUeKEY2w .fast-share-box {
  -ms-flex: 1;
  flex: 1;
}

.pU9uCahuI5X16Y5schiY .mmVblCO1C2DkoUeKEY2w .channel-box {
  -ms-flex: 2;
  flex: 2;
}
.M9sYhkFFQiFmM32ifMp5 {
  margin-bottom: 0.3rem;
  width: 100%;
}

.M9sYhkFFQiFmM32ifMp5 .u_ecgPCLkRaUsesukqAW {
  color: var(--theme-text-color-lighten);
  font-size: 0.24rem;
  margin-bottom: 0.18rem;
}

.M9sYhkFFQiFmM32ifMp5 .BCZ4CKkRqkon2n_mgG1Q {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  gap: 0.2rem;
}

.M9sYhkFFQiFmM32ifMp5 .BCZ4CKkRqkon2n_mgG1Q .UFAFwugOhgpx7Zb7eUTn {
  height: 0.7rem;
  width: 0.7rem;
}
</style>
